import React from 'react'
import AnimatedBackgroundContainer from 'components/common/AnimatedBackgroundContainer'
import styles from 'styles/pages/DefaultPage.module.sass'
import ChangePlanInvoiceForm from 'components/forms/ChangePlanInvoiceForm'

/**
 * ChangePlanInvoicePage component.
 * This component represents the Change Plan Invoice page of the application.
 * It is wrapped in an AnimatedBackgroundContainer to provide a visually appealing background.
 *
 * @component ChangePlanInvoicePage
 * 
 * @example
 * Usage:
 * ```tsx
 * import ChangePlanInvoicePage from 'components/pages/ChangePlanInvoicePage';
 * ```
 *
 * @returns {JSX.Element} The ChangePlanInvoicePage component.
 */
const ChangePlanInvoicePage: React.FC = () => {
    return (
        <div className={styles['page']}>
            <AnimatedBackgroundContainer showFooter={true}>
                <div className={styles['invoice-details']}>
                    <ChangePlanInvoiceForm />
                </div>
            </AnimatedBackgroundContainer>
        </div>
    )
}

export default ChangePlanInvoicePage